<template>
  <div class="grids">
    <v-btn
      color="primary"
      @click="clicked(item)"
      :disabled="!hasChild(item)"
      v-for="(item, i) in listA"
      :key="i"
      class="grid-item"
      :class="{ 'custom-disabled-btn': !hasChild(item) }"
    >
      {{ item }}
    </v-btn>
    <v-btn
      color="primary"
      @click="clicked(item)"
      :disabled="!hasChild(item)"
      v-for="(item, i) in listI"
      :key="i"
      class="grid-item"
      :class="{ 'custom-disabled-btn': !hasChild(item) }"
    >
      {{ item }}
    </v-btn>
    <v-btn
      color="primary"
      @click="clicked(item)"
      :disabled="!hasChild(item)"
      v-for="(item, i) in listU"
      :key="i"
      class="grid-item"
      :class="{ 'custom-disabled-btn': !hasChild(item) }"
    >
      {{ item }}
    </v-btn>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "KanaList",

  emits: ["kana-clicked"],

  props: {
    kanaArray: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      listA: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"],
      listI: ["K", "L", "M", "N", "O", "P", "Q", "R", "S", "T"],
      listU: ["U", "V", "W", "X", "Y", "Z", "-", "-", "-", "-"],
    };
  },

  methods: {
    hasChild(kana: string): boolean {
      return this.kanaArray.includes(kana);
    },
    clicked(value: string) {
      this.$emit("kana-clicked", value);
    },
  },
});
</script>

<style lang="scss" scoped>
.grids {
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  grid-auto-rows: minmax(10vh, auto);
  align-items: center;
  text-align: center;
  color: white;
  gap: 2px;
}

.grid-item {
  height: 100% !important;
}

.v-btn {
  font-size: 2em;
}

.custom-disabled-btn.v-btn--disabled {
  background-color: #9e9e9e !important; /* お好みのグレーのカラーコード */
  color: #ffffff !important; /* 文字色は白に固定 */
  opacity: 1 !important; /* Vuetify特有の「半透明になる」のを打ち消す */
}
</style>
